(() => {
  const ROOT_CLASS = 'pswp--privado-arcade';
  const RAIL_CLASS = 'privado-product-arcade-rail';
  const ACTION_CLASS = 'privado-product-arcade-action';
  const WHATSAPP_NUMBER = '96170659254';

  if (!document.body.classList.contains('template-product')) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getProductInfo = () => document.querySelector('main product-info[id^="ProductInfo-"]');

  const getProductForm = () => {
    const productInfo = getProductInfo();
    const formId = productInfo?.getAttribute('form');
    return formId ? document.getElementById(formId) : document.querySelector('main form[id^="ProductForm-"]');
  };

  const getSubmitButton = () => {
    const form = getProductForm();
    return form?.querySelector('button[name="add"][type="submit"], button[type="submit"]');
  };

  const getProductTitle = () => {
    const productInfo = getProductInfo();
    const heading = productInfo?.querySelector('.product__title :is(h1, h2, .heading)');
    const title =
      heading?.getAttribute('aria-label') ||
      document.querySelector('meta[property="og:title"]')?.content ||
      heading?.textContent ||
      document.title;

    return title.replace(/\s+/g, ' ').trim();
  };

  const closeLightbox = () => {
    document.querySelector('.pswp__button--close')?.click();
  };

  const scrollToProductDetails = () => {
    const target = getProductInfo();

    closeLightbox();

    if (!target) return;

    window.setTimeout(() => {
      target.scrollIntoView({
        block: 'start',
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }, 140);
  };

  const setActionText = (action, label, detail) => {
    action.querySelector(`.${ACTION_CLASS}__label`).textContent = label;
    action.querySelector(`.${ACTION_CLASS}__detail`).textContent = detail;
  };

  const createAction = ({ label, detail, primary = false, href = '', index = 0, onClick = null }) => {
    const action = href ? document.createElement('a') : document.createElement('button');
    action.className = `${ACTION_CLASS}${primary ? ` ${ACTION_CLASS}--primary` : ''}`;
    action.style.setProperty('--arcade-index', index);
    action.setAttribute('aria-label', `${label}. ${detail}`);

    if (href) {
      action.href = href;
      action.target = '_blank';
      action.rel = 'noopener noreferrer';
    } else {
      action.type = 'button';
    }

    if (onClick) {
      action.addEventListener('click', onClick);
    }

    const text = document.createElement('span');
    text.className = `${ACTION_CLASS}__text`;

    const labelElement = document.createElement('span');
    labelElement.className = `${ACTION_CLASS}__label`;
    labelElement.textContent = label;

    const detailElement = document.createElement('span');
    detailElement.className = `${ACTION_CLASS}__detail`;
    detailElement.textContent = detail;

    const mark = document.createElement('span');
    mark.className = `${ACTION_CLASS}__mark`;
    mark.setAttribute('aria-hidden', 'true');

    text.append(labelElement, detailElement);
    action.append(text, mark);

    return action;
  };

  const syncRailState = (rail) => {
    const submitButton = getSubmitButton();
    const addAction = rail.querySelector('[data-product-arcade-add]');
    const canAdd = submitButton && !submitButton.disabled && submitButton.getAttribute('aria-disabled') !== 'true';

    if (!addAction) return;

    addAction.disabled = !canAdd;
    addAction.setAttribute('aria-disabled', canAdd ? 'false' : 'true');

    if (canAdd) {
      setActionText(addAction, 'Add to cart', 'Keep viewing');
    } else {
      setActionText(addAction, 'Unavailable', 'Check details');
    }
  };

  const createRail = () => {
    const rail = document.createElement('div');
    rail.className = RAIL_CLASS;
    rail.setAttribute('aria-label', 'Product fullscreen actions');

    const addAction = createAction({
      label: 'Add to cart',
      detail: 'Keep viewing',
      primary: true,
      index: 0,
      onClick: () => {
        const submitButton = getSubmitButton();
        if (submitButton && !submitButton.disabled) submitButton.click();
      },
    });
    addAction.dataset.productArcadeAdd = 'true';

    const message = `Hi Privado, I have a question about ${getProductTitle()}: ${window.location.href}`;
    const askAction = createAction({
      label: 'Ask Privado',
      detail: 'WhatsApp support',
      href: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`,
      index: 1,
    });

    const detailsAction = createAction({
      label: 'Product details',
      detail: 'Return to page',
      index: 2,
      onClick: scrollToProductDetails,
    });

    rail.append(addAction, askAction, detailsAction);
    syncRailState(rail);

    return rail;
  };

  const enhanceOpenLightbox = () => {
    const lightbox = document.querySelector('.pswp.pswp--open');
    if (!lightbox) return;

    lightbox.classList.add(ROOT_CLASS);

    let rail = lightbox.querySelector(`.${RAIL_CLASS}`);
    if (!rail) {
      rail = createRail();
      lightbox.appendChild(rail);
    }

    syncRailState(rail);
  };

  const cleanupClosedLightboxes = () => {
    document.querySelectorAll(`.pswp.${ROOT_CLASS}:not(.pswp--open)`).forEach((lightbox) => {
      lightbox.classList.remove(ROOT_CLASS);
      lightbox.querySelector(`.${RAIL_CLASS}`)?.remove();
    });
  };

  const scheduleEnhancement = () => {
    window.requestAnimationFrame(() => {
      enhanceOpenLightbox();
      cleanupClosedLightboxes();
    });
  };

  const observer = new MutationObserver(scheduleEnhancement);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });

  document.addEventListener('variant:change', scheduleEnhancement);
  document.addEventListener('DOMContentLoaded', scheduleEnhancement);
})();
